import { render } from "./FormCadastro.vue?vue&type=template&id=d278767a&scoped=true"
import script from "./FormCadastro.vue?vue&type=script&lang=js"
export * from "./FormCadastro.vue?vue&type=script&lang=js"

import "./FormCadastro.vue?vue&type=style&index=0&id=d278767a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d278767a"]])

export default __exports__